// src/utils/statusFormatter.js
// ฟังก์ชันแปลงสถานะเป็นภาษาไทย ใช้ร่วมกันทั่วทั้ง app

export const getOrderStatusText = (status) => {
  switch (status) {
    case "draft":
      return "ยังไม่ชำระ";
    case "paid":
      return "ชำระแล้ว";
    case "canceled":
      return "ยกเลิก";
    default:
      return status || "-";
  }
};

export const getEmployeeStatusText = (status) => {
  switch (status) {
    case "active":
      return "เปิดใช้งาน";
    case "inactive":
      return "ปิดใช้งาน";
    default:
      return status || "-";
  }
};

export const getStatusBadgeClass = (status, type = "order") => {
  if (type === "order") {
    switch (status) {
      case "draft":
        return "bg-secondary";
      case "paid":
        return "bg-success";
      case "canceled":
        return "bg-danger";
      default:
        return "bg-secondary";
    }
  } else if (type === "employee") {
    switch (status) {
      case "active":
        return "bg-success";
      case "inactive":
        return "bg-secondary";
      default:
        return "bg-secondary";
    }
  }
};

// ฟังก์ชันสำหรับแสดง badge พร้อมข้อความ
export const StatusBadge = ({ status, type = "order" }) => {
  const statusText = type === "order" 
    ? getOrderStatusText(status)
    : getEmployeeStatusText(status);
  const badgeClass = getStatusBadgeClass(status, type);

  return <span className={`badge ${badgeClass}`}>{statusText}</span>;
};
